import React, { useState, useEffect } from 'react';
import { Layout, Segment } from 'tea-component';
import SearchHome from './SearchHome';
import SearchDetails from './SearchDetails';
import '@/pages/home/assets/scss/components/sreachContext.scss';
import {
  getSearchPageParams,
  updateSearchPageUrl,
  DEFAULT_SEARCH_PARAMS,
  DEFAULT_PAGE_SIZE,
} from '@/pages/home/utils/search';
import {
  fetchSearchTrendings,
  fetchAddSearchHistory,
  fetchSearchResult,
  // fetchGameListPermissions,
  // fetchGameListDashboardPermissions,
} from '@/pages/home/services/search';
import { history, useLocation, connect, useIntl } from 'umi';
import SvgIcon from '../../SvgIcon';
import { IS_SEARCH_HOME, setWindowState, getEntityTypeParms } from '@/pages/home/utils/state';
import { buriedPointSearch } from '@/pages/home/utils/buriedPoint';
import { PageLogMes } from '@/pages/home/utils/buriedPointCfg';
// import { isEmpty } from '@/pages/intelligence/utils/commonUtils';
import UserGuideCompetitor from '@op/components/UserGuide/competitor';
import IntelligenceUserGuideCompetitor from '@intelligence/components/UserGuide/Competitor';
import IntelligenceUserGuideCompany from '@intelligence/components/UserGuide/Company';
// import type { DashGameType, SearchGameType } from '../_config';
// import {
//   getSearchSortNum,
//   getCombineIDGameList,
//   getListValueSplit,
//   getSortSearchGamesCommon,
//   getSortSearchGames,
// } from './utils';
// import { useQueryDefinition } from '@intelligence/hooks/useQueryDefinition';
const { Content } = Layout;

function SreachContext(props: any) {
  const { searchTime, userInfo } = props;
  const { formatMessage } = useIntl(); // 中英切换方法
  // const { homeSearchCfg } = useQueryDefinition();
  const segmentList = [
    {
      text: (
        <>
          <SvgIcon type="home-page-all" />
          {formatMessage({ id: 'dbh_all' })}
        </>
      ),
      value: 'all',
    },
    {
      text: (
        <>
          <SvgIcon type="other-icon" />
          {formatMessage({ id: 'dbh_mobile' })}
        </>
      ),
      value: 'mobile',
    },
    {
      text: (
        <>
          <SvgIcon type="pc-console-combine" />
          {formatMessage({ id: 'dbh_pcconsole' })}
        </>
      ),
      value: 'pcconsole',
    },
    {
      text: (
        <>
          <SvgIcon type="monitor" />
          {formatMessage({ id: 'dbh_pc' })}
        </>
      ),
      value: 'pc',
    },
    {
      text: (
        <>
          <SvgIcon type="game" style={{ fontSize: '13px' }} />
          {formatMessage({ id: 'dbh_console' })}
        </>
      ),
      value: 'console',
    },
    {
      text: (
        <div className="search-home-segment-line">
          <SvgIcon type="folded-graph" />
          {formatMessage({ id: 'dbh_company' })}
        </div>
      ),
      value: 'company',
    },
  ];
  const [isHome, setIsHome] = useState(true);

  useLocation();
  // 确定是否更新搜索结果页面
  const [ifReloadUrl, setIfReloadUrl] = useState(true);
  const [ifSearchHomeInit, setIfSearchHomeInit] = useState(true);
  const [searchLoading, setSearchLoading] = useState(true);
  const [disabledSegment, setDisabledSegment] = useState(false);
  const [searchTrendingsLoading, setSearchTrendingsLoading] = useState(true);
  const [searchResultList, setSearchResultList] = useState<any[]>([]);
  const [searchResultTotal, setSearchResultTotal] = useState(0);
  const [srParamsPage, setSrParamsPage] = useState(1);
  const [srParamsPageSize, setSrParamsPageSize] = useState(DEFAULT_PAGE_SIZE);
  // 当前选中游戏、公司
  const [currentItem, setCurrentItem] = useState({});
  const [trendingList, setTrendingList] = useState([]);
  const [searchType, setSearchType] = useState<string>('all');
  const [intelligenceLoading, setIntelligenceLoading] = useState(true);
  const [isWhiteCompany, setIsWhiteCompany] = useState(false);
  const [forceSearch, setForceSearch] = useState(false);
  // 获取搜索推荐信息
  const getSearchTrendings = async (value = '') => {
    setSearchTrendingsLoading(true);
    const params = {
      search_type: value,
      page: 1,
      page_size: 20,
    };
    try {
      const resultData: any = await fetchSearchTrendings(params);
      const hotList = Array.isArray(resultData?.data) ? resultData?.data : [];
      // 添加三个需要显示2个月的，新上线的游戏Trending Games Datas
      // const hotList = value === 'all' ? addUpcomingTrendsGames(hotListTemp) : hotListTemp;
      // console.log('resultData', resultData);
      setTrendingList(hotList);
    } catch (err) {
    } finally {
      setSearchTrendingsLoading(false);
      setDisabledSegment(false);
    }
  };

  // 添加搜索记录,记录游戏
  const addSearchHistoryGame = (text: String, searchObj: any) => {
    fetchAddSearchHistory({
      open_id: userInfo?.openid,
      keyword: text,
      info: searchObj ? searchObj : {},
    });
  };

  const setGameListReachStart = (list: any) => {
    setSearchResultList(list);
    // 若没有匹配的，选中第一个
    const arrTemp = list.find((item: any) => item.game_id == getSearchPageParams().unid) || list[0];
    setCurrentItem({ ...arrTemp });
    updateSearchPageUrl({ ...getSearchPageParams(), unid: arrTemp.game_id });
  };

  // 手动翻页功能
  const paginateList = (list: any[], page = 1, pageSize = 10) => {
    if (Array.isArray(list) && list?.length > 0) {
      let pageValue = page;
      // 计算总页数
      const totalItems = list?.length || 0;
      const totalPages = Math.ceil(totalItems / pageSize);
      // 如果页数超过总页数，则使用最后一页
      if (pageValue > totalPages) {
        pageValue = totalPages;
      }
      // 计算起始和结束索引
      const startIndex = (pageValue - 1) * pageSize;
      const endIndex = pageValue * pageSize;
      // 截取列表的相应部分
      return list?.slice(startIndex, endIndex);
    }
    return list;
  };

  const searchResultHandle = async (params: any) => {
    const { page = 1, page_size = 10 } = params || {};
    setSearchLoading(true);
    setIntelligenceLoading(true);

    const paramsValue = {
      ...params,
      entity_type: getEntityTypeParms(params.entity_type),
      force_search: forceSearch,
    };
    try {
      const resultData: any = await fetchSearchResult(paramsValue);
      const { list = [] } = resultData?.data || {};
      const req = resultData?.req || {};
      if (Array.isArray(list) && list?.length > 0) {
        setSearchResultTotal(list?.length);
        // getGameListPermissions(list, page, page_size, paramsValue?.keyword);
        setGameListReachStart(paginateList([...list], page, page_size));
        setIfReloadUrl(false);
      } else {
        setSearchResultList([]);
        setSearchResultTotal(0);
        setCurrentItem({});
        setIntelligenceLoading(false);
      }
      setIsWhiteCompany(req?.is_white_company);
      if (req?.entity_type == 'company' && searchType != 'company') {
        updateSearchPageUrl({ ...getSearchPageParams(), type: 'company' });
        setForceSearch(false);
        setSearchType('company');
      }
    } catch (err) {
      setSearchResultList([]);
      setSearchResultTotal(0);
      setCurrentItem({});
      setIntelligenceLoading(false);
    } finally {
      setSearchLoading(false);
      setDisabledSegment(false);
    }
  };

  const getPageParams = (page: string | number) => {
    // 最多两页，超过2页，则返回第1页
    const pageCur = Number(page);
    return pageCur;
    // return pageCur > 2 ? 1 : pageCur;
  };

  const pullDownAndSearch = async (searchPageParams = DEFAULT_SEARCH_PARAMS) => {
    setSearchResultList([]);
    setSearchResultTotal(0);
    setCurrentItem({});
    const params = {
      keyword: searchPageParams.kw || '',
      entity_type: searchPageParams.type || 'all',
      system_type: 'pc',
      page: getPageParams(searchPageParams.page) || 1,
      page_size: Number(searchPageParams.pageSize) || DEFAULT_PAGE_SIZE,
      ids: [],
    };
    searchResultHandle(params);
    // 搜索打点
    buriedPointSearch(PageLogMes.searchDetail, searchPageParams.kw || '');
  };
  const handleClickBack = () => {
    // 如果
    if (history.action === 'PUSH' || history.length > 1) {
      history.goBack();
    } else {
      history.push('/home');
    }
  };
  // 切换搜索类型的调用方法
  const searchTypeHandle = (value: string) => {
    setIfReloadUrl(true);
    updateSearchPageUrl({ ...getSearchPageParams(), type: value, page: 1 }, false);
    setDisabledSegment(true);
    setSearchType(value);
    setIntelligenceLoading?.(true);
    setForceSearch(true);
  };

  // 根据url变化，获取path搜索参数
  useEffect(() => {
    const searchParams = getSearchPageParams();
    const { kw, type, page, pageSize } = searchParams;

    if (!kw && ['PUSH', 'POP'].includes(history.action)) {
      setWindowState(IS_SEARCH_HOME, true);
    } else {
      setWindowState(IS_SEARCH_HOME, false);
    }
    if (kw != '') {
      setIsHome(false);
    } else {
      getSearchTrendings(type || 'all');
      setIsHome(true);
    }
    if (ifReloadUrl) {
      if (kw != '') {
        pullDownAndSearch(searchParams);
      }
    }

    setForceSearch(false);
    setIfSearchHomeInit(false);
    setSearchType(type || 'all');
    setSrParamsPage(getPageParams(page) || 1);
    setSrParamsPageSize(pageSize || DEFAULT_PAGE_SIZE);
    setIfReloadUrl(true);
  }, [history.location]);

  return (
    <Content.Body full>
      <UserGuideCompetitor></UserGuideCompetitor>
      {searchLoading || (
        <>
          <IntelligenceUserGuideCompetitor />
          <IntelligenceUserGuideCompany />
        </>
      )}

      {ifSearchHomeInit ? null : (
        <>
          {isHome ? (
            <SearchHome
              handleClickBack={handleClickBack}
              trendingList={trendingList}
              searchTrendingsLoading={searchTrendingsLoading}
              addSearchHistory={addSearchHistoryGame}
              openDetails={() => {
                setIsHome(false);
              }}
              setIfReloadUrl={setIfReloadUrl}
            >
              <Segment
                className="search-home-segment"
                value={searchType}
                onChange={searchTypeHandle}
                options={segmentList}
                // disabled={disabledSegment}
              />
            </SearchHome>
          ) : (
            <>
              {/* {searchLoading ? (
                <LodingData />
              ) : (
                <> */}
              {/* {searchResultTotal > 0 ? ( */}
              <SearchDetails
                handleClickBack={handleClickBack}
                searchResultList={searchResultList}
                searchResultTotal={searchResultTotal}
                currentItem={currentItem}
                setCurrentItem={setCurrentItem}
                searchTime={searchTime}
                setIfReloadUrl={setIfReloadUrl}
                setForceSearch={setForceSearch}
                setSrParamsPage={setSrParamsPage}
                srParamsPage={srParamsPage}
                srParamsPageSize={srParamsPageSize}
                addSearchHistory={addSearchHistoryGame}
                searchLoading={searchLoading}
                intelligenceLoading={intelligenceLoading}
                setIntelligenceLoading={setIntelligenceLoading}
                searchType={searchType}
                searchTypeHandle={searchTypeHandle}
                isWhiteCompany={isWhiteCompany}
              >
                <Segment
                  className={`search-home-segment ${
                    searchType == 'company' && isWhiteCompany ? 'dbh-mb-16' : ''
                  }`}
                  value={searchType}
                  onChange={searchTypeHandle}
                  options={segmentList}
                  // disabled={disabledSegment}
                />
              </SearchDetails>
              {/* ) : (
                    <NoData />
                  )} */}
              {/* </>
              )} */}
            </>
          )}
        </>
      )}
    </Content.Body>
  );
}

export default connect((state: any) => {
  const { home, searchModels } = state;
  return {
    userInfo: home.userInfo,
    searchTime: searchModels.searchTime,
  };
})(SreachContext);
